<ion-button class="ion-no-padding" (click)="showSearchBar()">
	<ion-icon slot="start" class="icon-Search"></ion-icon>
</ion-button>
